import { render, staticRenderFns } from "./SystemPage.vue?vue&type=template&id=15645de9&scoped=true&"
import script from "./SystemPage.vue?vue&type=script&lang=js&"
export * from "./SystemPage.vue?vue&type=script&lang=js&"
import style0 from "./SystemPage.vue?vue&type=style&index=0&id=15645de9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15645de9",
  null
  
)

export default component.exports